import { ESCUDO } from './escudo-estelar.js';
import { COFRE } from './cofre-quantico.js';
import { NEBULOSA } from './rede-nebulosa.js';
import { assertCourseShape } from '../engine/index.js';

export const COURSES = Object.freeze([ESCUDO, COFRE, NEBULOSA]);

export function courseById(id) {
  const course = COURSES.find((c) => c.id === id);
  if (!course) throw new Error(`CURSO_DESCONHECIDO:${id}`);
  return course;
}

export function validateCatalog() {
  for (const course of COURSES) assertCourseShape(course);
  return true;
}

export const GABARITO = Object.freeze({
  'escudo-estelar': [
    { id: 'c1-q1', slide: 9, correct: 'B', line: 'Telefone + pedido identificam o João' },
    { id: 'c1-q2', slide: 10, correct: 'B', line: 'Print no Slack da loja é tratamento' },
    { id: 'c1-q3', slide: 17, correct: 'B', line: 'NFC-e com CPF = obrigação legal' },
    { id: 'c1-q4', slide: 18, correct: 'B', line: '“Por via das dúvidas” não é base' },
    { id: 'c1-q5', slide: 25, correct: 'B', line: 'Encaminha, não apaga sozinho' },
    { id: 'c1-q6', slide: 26, correct: 'B', line: 'Identidade antes de mandar extrato' },
    { id: 'c1-q7', slide: 27, mustInclude: ['nome'], line: 'Nome é dado pessoal' },
    { id: 'c1-q8', slide: 27, mustInclude: ['telefone'], line: 'Telefone é dado pessoal' },
    {
      id: 'c1-q9',
      slide: 27,
      mustInclude: ['foto'],
      mustExclude: ['coxinha'],
      line: 'Foto+CPF sim; coxinha campeã sozinha não',
    },
  ],
  'cofre-quantico': [
    { id: 'c2-q1', slide: 9, correct: 'B', line: 'Alergia pode ser saúde; canal da operação' },
    { id: 'c2-q2', slide: 10, correct: 'B', line: 'Apagar o Slack não recolhe a senha' },
    { id: 'c2-q3', slide: 17, correct: 'B', line: 'Face no estoque = biometria; Encarregado antes' },
    { id: 'c2-q4', slide: 18, correct: 'B', line: 'DPO não come a responsabilidade da empresa' },
    { id: 'c2-q5', slide: 25, correct: 'B', line: 'CSV no canal aberto: contém e avisa agora' },
    { id: 'c2-q6', slide: 26, correct: 'B', line: 'ANPD se comunica pelo fluxo oficial' },
    {
      id: 'c2-q7',
      slide: 27,
      mustInclude: ['o-que', 'quando'],
      line: 'O que e quando',
    },
    {
      id: 'c2-q8',
      slide: 27,
      mustInclude: ['tipo', 'quantas'],
      line: 'Tipo de dado e quantas pessoas',
    },
    {
      id: 'c2-q9',
      slide: 27,
      mustExclude: ['print'],
      line: 'Sem print da base',
    },
  ],
  'rede-nebulosa': [
    { id: 'c3-q1', slide: 9, correct: 'B', line: 'Integração não se testa com a base de produção' },
    { id: 'c3-q2', slide: 10, correct: 'B', line: 'SaaS nos EUA = transferência; jurídico antes' },
    { id: 'c3-q3', slide: 17, correct: 'B', line: 'Decisão de máquina tem revisão humana' },
    { id: 'c3-q4', slide: 18, correct: 'B', line: 'Ticket real em IA pública é compartilhamento' },
    { id: 'c3-q5', slide: 25, correct: 'B', line: 'Não avisar 12 mil pelo Gmail pessoal' },
    { id: 'c3-q6', slide: 26, correct: 'B', line: '2% / R$ 50 mi por infração' },
    { id: 'c3-q7', slide: 27, mustInclude: ['avisar'], line: 'Avisar segurança e Encarregado' },
    { id: 'c3-q8', slide: 27, mustInclude: ['nao-reenviar'], line: 'Não reenviar o CSV' },
    {
      id: 'c3-q9',
      slide: 27,
      mustInclude: ['contar', 'parar'],
      mustExclude: ['postar', 'gmail', 'imprensa'],
      line: 'Contar e parar o fornecedor; sem megafone',
    },
  ],
});
